import { MAX_DECIMAL } from "../../../../common/Configurations/DecimalConfiguration";
import { WAIVED } from "../members/member/coverage/enums/memberCoverageGuaranteeTypes";

export const PREMIUM_SIMULATOR_VALIDATION_RULES = {
  employeeType: {
    isRequired: {
      value: true,
    },
  },
  memberId: {
    isRequiredTrimIfFieldHasValue: {
      value: { field: "employeeType", expectedValues: ["existing"] },
    },
  },
  payrollFrequency: {
    isRequiredTrim: {
      value: true,
    },
  },
  languageCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  lastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  firstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  classId: {
    isRequiredTrim: {
      value: true,
    },
  },
  divisionId: {
    isRequiredTrim: {
      value: true,
    },
  },
  birthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  salary: {
    isRequiredTrim: {
      value: true,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  memberCoverageGuarantees: {
    array: {
      coverageType: {
        isRequiredTrimIfFieldsValueDoesNotEqual: {
          value: {
            expectedValues: [WAIVED.value]
          },
        }
      },
      invoicedClientRate: {
        isRequiredTrimIfField: {
          value: {
            field: "invoicedClientRate",
          },
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },isRequiredTrim: {
          value: true
        }
      },
      allowance: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        }, isRequiredTrim: {
          value: true
        }
      },
      volume: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        }, 
        isRequiredTrim: {
          value: true
        }
      },
      formulaMspa: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        }
      },
      ageOfPolicyExpiration: {
        isRequiredTrimIfOtherFieldIsSet: {
          value: {
            field: "ageOfPolicyExpiration",
            otherField: "coverageType",
            excludeOtherFieldValues: [WAIVED.value]
          },
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      ageOfPolicyDecrease: {
        isRequiredTrimIfOtherFieldIsSet: {
          value: {
            field: "ageOfPolicyDecrease",
            otherField: "coverageType",
            excludeOtherFieldValues: [WAIVED.value]
          },
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
    },
    atLeastOne: {
      value: {
        field: "checked",
        expectedValue: true,
        customMessageKey: "memberCoverages.validation.guaranteeSelection",
      },
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorValidationRules.js